import { Reducer } from "redux";

import { GetApprovedVisitsResponse } from "../models/Api/Discipline";
import { GetApprovedVisitsDispatchTypes } from "../models/DispatchTypes/Discipline";
import { ApproveVisitsActionDispatchTypes } from "../constants/AllPatientRecord";

export const initialGetState: GetApprovedVisitsResponse = {
    loading: false,
    response: {
        referralId: -1,
        sn: 0,
        pt: 0,
        ot: 0,
        st: 0,
        msw: 0,
        hha: 0,
        totalApproved: 0
    },
    error: null,
};

const ApprovedVisitsReducer: Reducer<
    GetApprovedVisitsResponse,
    GetApprovedVisitsDispatchTypes
> = (state = initialGetState, action) => {
    switch (action.type) {
        case ApproveVisitsActionDispatchTypes.GET_APPROVED_VISITS_INVOKE: {
            return {
                ...state,
                loading: true,
            };
        }
        case ApproveVisitsActionDispatchTypes.GET_APPROVED_VISITS_SUCCESS: {
            return {
                ...state,
                response: action.response,
                loading: false,
            };
        }

        case ApproveVisitsActionDispatchTypes.GET_APPROVED_VISITS_ERROR: {
            return {
                ...state,
                error: action.error,
                loading: false,
            };
        }
        case ApproveVisitsActionDispatchTypes.GET_APPROVED_VISITS_RESET: {
            return initialGetState;
        }
    }
    return state;
};

export default ApprovedVisitsReducer;
